/* Salon Official – Collection-Seite: Filter-Schublade, Schnellfilter, Ansicht, Schnell-Kaufen, Merkliste, Effekte */
(function(){
  if (window.__scColl) return; window.__scColl = 1;
  var q = function(s, r){ return [].slice.call((r || document).querySelectorAll(s)); };
  var desktop = function(){ return matchMedia('(min-width:751px)').matches; };

  function toast(root, msg){
    var t = root.querySelector('.sc-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(t._h);
    t._h = setTimeout(function(){ t.classList.remove('on'); }, 2200);
  }
  function drawer(root, open){
    root.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    var b = root.querySelector('[data-sc-open]'); if (b) b.setAttribute('aria-expanded', open);
    if (open) { var c = root.querySelector('.sc-fhead button'); if (c && !desktop()) setTimeout(function(){ c.focus(); }, 50); }
  }
  function load(root){ root.classList.add('is-loading'); }
  function submitForm(form){
    q('input[type=number]', form).forEach(function(i){ if (i.value === '') i.disabled = true; });
    load(form.closest('.sc-prod')); form.submit();
  }
  function go(root, params){ params.delete('page'); load(root); location.search = params.toString(); }

  /* Schnellfilter markieren */
  function markQuick(){
    var p = new URLSearchParams(location.search);
    q('[data-sc-qf]').forEach(function(b){
      try {
        var m = JSON.parse(b.dataset.scQf), on = Object.keys(m).every(function(k){ return p.get(k) === String(m[k]); });
        b.setAttribute('aria-pressed', on);
      } catch (x) {}
    });
  }

  document.addEventListener('click', function(e){
    var root = e.target.closest('.sc-prod'); if (!root) return;
    if (e.target.closest('[data-sc-open]')) { drawer(root, true); return; }
    if (e.target.closest('[data-sc-close]')) { drawer(root, false); return; }

    var qf = e.target.closest('[data-sc-qf]');
    if (qf) {
      var m = JSON.parse(qf.dataset.scQf), p = new URLSearchParams(location.search);
      var on = qf.getAttribute('aria-pressed') === 'true';
      Object.keys(m).forEach(function(k){ if (k.indexOf('price') > -1) { p.delete('filter.v.price.gte'); p.delete('filter.v.price.lte'); } });
      Object.keys(m).forEach(function(k){ if (on) p.delete(k); else p.set(k, m[k]); });
      go(root, p); return;
    }
    var v = e.target.closest('[data-sc-cols]');
    if (v) {
      var g = root.querySelector('[data-sc-grid]'); g.style.setProperty('--cols', v.dataset.scCols);
      q('[data-sc-cols]', root).forEach(function(b){ b.setAttribute('aria-pressed', b === v); });
      try { localStorage.setItem('sc-cols', v.dataset.scCols); } catch (x) {}
      return;
    }
    var h = e.target.closest('.sc-heart');
    if (h) {
      e.preventDefault();
      var on2 = h.classList.toggle('on'); h.textContent = on2 ? '♥' : '♡';
      try {
        var w = JSON.parse(localStorage.getItem('so-wish') || '[]'), id = h.dataset.id, i = w.indexOf(id);
        if (i > -1) w.splice(i, 1); else w.push(id);
        localStorage.setItem('so-wish', JSON.stringify(w));
      } catch (x) {}
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') q('.sc-prod.is-open').forEach(function(r){ drawer(r, false); });
  });

  document.addEventListener('change', function(e){
    var el = e.target, form = el.form;
    if (!form || !form.hasAttribute('data-sc-form')) return;
    if (el.hasAttribute('data-sc-sort')) { submitForm(form); return; }
    if (!desktop() || form.dataset.scAuto === 'false') return;
    clearTimeout(form._t); form._t = setTimeout(function(){ submitForm(form); }, 350);
  });

  document.addEventListener('submit', function(e){
    var f = e.target;
    if (f.hasAttribute && f.hasAttribute('data-sc-form')) {
      q('input[type=number]', f).forEach(function(i){ if (i.value === '') i.disabled = true; });
      load(f.closest('.sc-prod'));
    }
    if (f.matches && f.matches('[data-sc-add]')) {
      e.preventDefault();
      var root = f.closest('.sc-prod'), btn = f.querySelector('button'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
        .then(function(r){ if (!r.ok) throw 0; return r.json(); })
        .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
        .then(function(c){
          q('[data-so-cart-count],.cart-count-bubble span,#cart-icon-bubble .cart-count-bubble').forEach(function(el){ el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('so:cart-updated', { detail: c }));
          toast(root, root.dataset.scAdded || 'Zum Warenkorb hinzugefügt');
        })
        .catch(function(){ toast(root, 'Konnte nicht hinzugefügt werden'); })
        .then(function(){ btn.disabled = false; });
    }
  });

  function init(){
    var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
    var cards = q('.sc-rv:not(.in)');
    if (reduce || !('IntersectionObserver' in window)) cards.forEach(function(c){ c.classList.add('in'); });
    else {
      var o = new IntersectionObserver(function(es){ es.forEach(function(x){ if (x.isIntersecting) { x.target.classList.add('in'); o.unobserve(x.target); } }); }, { threshold: .08 });
      cards.forEach(function(c){ o.observe(c); });
    }
    q('[data-sc-count]').forEach(function(el){
      var to = +el.dataset.scCount; if (reduce || !to) return; var t0 = null;
      requestAnimationFrame(function s(t){ t0 = t0 || t; var p = Math.min((t - t0) / 900, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(s); });
    });
    try {
      var w = JSON.parse(localStorage.getItem('so-wish') || '[]');
      q('.sc-heart').forEach(function(h){ if (w.indexOf(h.dataset.id) > -1) { h.classList.add('on'); h.textContent = '♥'; } });
      var sc = localStorage.getItem('sc-cols');
      if (sc && desktop()) q('[data-sc-grid]').forEach(function(g){
        if (g.closest('.sc-prod').querySelector('[data-sc-cols="' + sc + '"]')) {
          g.style.setProperty('--cols', sc);
          q('[data-sc-cols]', g.closest('.sc-prod')).forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.scCols === sc); });
        }
      });
    } catch (x) {}
    markQuick();
    q('.sc-bar--sticky').forEach(function(bar){
      var f = function(){ bar.classList.toggle('sc-bar--stuck', bar.getBoundingClientRect().top <= (parseInt(getComputedStyle(bar).top, 10) || 0) + 1 && scrollY > 200); };
      addEventListener('scroll', f, { passive: true }); f();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  addEventListener('pageshow', function(){ q('.sc-prod.is-loading').forEach(function(r){ r.classList.remove('is-loading'); }); });
})();
